import { render, staticRenderFns } from "./out-type-select-new.vue?vue&type=template&id=0bcd780c&"
import script from "./out-type-select-new.vue?vue&type=script&lang=js&"
export * from "./out-type-select-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports